import request from '@/utils/request';
import {
  endpoints, workflowEndpoint,
} from '@/constants/urls';

const workflows = (includeEnabled, includeDisabled) => {
  const params = {};

  const enabledFlags = [includeEnabled, includeDisabled];
  const allSet = enabledFlags.every((v) => v === enabledFlags[0]);

  if (!allSet) {
    if (includeEnabled) {
      params.enabled = true;
    }
    if (includeDisabled) {
      params.disabled = true;
    }
  }

  return request({
    method: 'GET',
    params,
    url: endpoints.WORKFLOWS,
  });
};

const workflow = (code) => request({
  url: workflowEndpoint(code),
  method: 'GET',
});

const WorkflowsService = {
  workflows,
  workflow,
};

export default WorkflowsService;
